/*
  RLG 23.09.2026 – Audit F5 (google-shopping-conversion-audit_20260922):
  - Banner wird direkt beim Laden initialisiert (auch auf Touch-Geräten, kein theme.initWhenVisible mehr)
    und ohne Verzögerung gezeigt (Section-Einstellung delay = 0).
  - Guard gegen doppeltes init()/load(): ein Klick-Handler je Button, kein erneutes Einblenden nach der Wahl.
  - Einblenden nur, solange der Besucher noch keine Wahl getroffen hat (getTrackingConsent() === 'no_interaction').
  - Granulare Consent-API statt der veralteten binären setTrackingConsent(true/false).
  Texte und Buttons (Akzeptieren / Ablehnen, gleichrangig) sind unverändert.
*/
class CookieBanner extends ModalElement {
  constructor() {
    super();

    this._rlgInitDone = false;
    this._rlgLoaded = false;
    this.init();
  }

  get testMode() {
    return this.getAttribute('data-test-mode') === 'true';
  }

  get delay() {
    const value = this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay'), 10) : 0;
    return isNaN(value) || value < 0 ? 0 : value;
  }

  get acceptButton() {
    return this.querySelector('button[name="accept"]');
  }

  get declineButton() {
    return this.querySelector('button[name="decline"]');
  }

  get customerPrivacy() {
    return (window.Shopify && window.Shopify.customerPrivacy) || null;
  }

  init() {
    if (this._rlgInitDone) return;
    this._rlgInitDone = true;

    if (this.testMode) {
      this.load(this.delay);
      return;
    }

    window.Shopify.loadFeatures([{
      name: 'consent-tracking-api',
      version: '0.1',
      onLoad: this.onConsentLibraryLoaded.bind(this)
    }]);
  }

  load(delay) {
    if (Shopify && Shopify.designMode) return;
    if (this._rlgLoaded) return;
    this._rlgLoaded = true;

    if (this.acceptButton) this.acceptButton.addEventListener('click', this.acceptPolicy.bind(this));
    if (this.declineButton) this.declineButton.addEventListener('click', this.declinePolicy.bind(this));

    setTimeout(() => {
      if (this.testMode || this.needsChoice()) this.show();
    }, delay * 1000);
  }

  needsChoice() {
    const privacy = this.customerPrivacy;
    if (!privacy || typeof privacy.getTrackingConsent !== 'function') return true;
    return privacy.getTrackingConsent() === 'no_interaction';
  }

  setConsent(value) {
    const privacy = this.customerPrivacy;
    if (!privacy || typeof privacy.setTrackingConsent !== 'function') return;

    privacy.setTrackingConsent({
      analytics: value,
      marketing: value,
      preferences: value,
      sale_of_data: value
    }, this.noop);
  }

  acceptPolicy() {
    this.hide();
    this.setConsent(true);
  }

  declinePolicy() {
    this.hide();
    this.setConsent(false);
  }

  onConsentLibraryLoaded(error) {
    const privacy = this.customerPrivacy;
    if (error || !privacy) return;

    const userCanBeTracked = privacy.userCanBeTracked();
    const userTrackingConsent = privacy.getTrackingConsent();

    if (!userCanBeTracked && userTrackingConsent === 'no_interaction') {
      this.load(this.delay);
    }
  }

  noop() {
  }

  afterHide() {
    super.afterHide();
    document.body.classList.remove('has-cookie-banner');
  }
  afterShow() {
    super.afterShow();
    document.body.classList.add('has-cookie-banner');
  }
}
customElements.define('cookie-banner', CookieBanner);
